<template>
  <div class="table-page-wrapper">
    <div class="search-wrapper">
      <search-channel-select v-model="queryParams.mediaId" style="margin-right: 15px" />
      <search-dsp-select v-model="queryParams.dspId" :dspType="100" style="margin-right: 15px" />
      <search-dsp-slot-select v-model="queryParams.dspSlotId" :dspId="queryParams.dspId" style="margin-right: 15px" />
      <el-input v-model="queryParams.advertiser" placeholder="广告主" clearable size="medium" style="margin-right: 15px" />
      <el-select v-model="queryParams.enabled" placeholder="启用状态" clearable size="medium" style="margin-right: 15px">
        <el-option label="开启" :value="1" />
        <el-option label="关闭" :value="0" />
      </el-select>
      <el-button @click="handleSearch" type="primary" size="medium" round>搜索</el-button>
      <el-button @click="handleReset" size="medium" round>重置</el-button>
    </div>

    <div class="table-wrapper">
      <div class="table__operation">
        <el-button @click="handleAdd" type="primary" size="small" round>新增</el-button>
        <el-button @click="handleBatchDelete" type="danger" size="small" round :disabled="!selectedIds.length">批量删除</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        border
        highlight-current-row
        size="small"
        class="js-table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="channelName" label="媒体名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="dspNames" label="需求方" min-width="150" show-overflow-tooltip />
        <el-table-column prop="dspSlotNames" label="需求方广告位" min-width="150" show-overflow-tooltip />
        <el-table-column prop="advertiser" label="广告主" min-width="100" show-overflow-tooltip />
        <el-table-column prop="setName" label="创意集名称" min-width="150" show-overflow-tooltip />
        <el-table-column label="启用状态" width="100" align="center">
          <template v-slot="scope">
            <el-switch
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="0"
              @change="handleEnabledChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="替换策略" width="100" align="center">
          <template v-slot="scope">
            <el-tag :type="scope.row.replaceStrategy === 1 ? '' : 'success'" size="small">
              {{ scope.row.replaceStrategy === 1 ? '随机' : '轮询' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="160" align="center" />
        <el-table-column prop="updateTime" label="修改时间" width="160" align="center" />
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template v-slot="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="mini">编辑</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="mini" style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 16px; text-align: right"
      />
    </div>

    <m-form @submit="fetchData" ref="form" />
  </div>
</template>

<script>
import { getCreativeReplaceConfigList, deleteCreativeReplaceConfig, updateCreativeReplaceConfig } from '@/api/manage/creativeReplace/creativeReplace'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import mForm from './form'

export default {
  name: 'CreativeReplace',
  components: {
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    mForm
  },
  data () {
    return {
      loading: false,
      tableData: [],
      selectedIds: [],
      queryParams: {
        mediaId: '',
        dspId: '',
        dspSlotId: '',
        advertiser: '',
        enabled: null
      },
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.buildQueryParams()
        }
        const res = await getCreativeReplaceConfigList(params)
        if (res && res.data) {
          this.tableData = res.data.records || []
          this.pagination.total = res.data.total || 0
        }
      } catch (e) {
        console.error('查询替换配置列表失败', e)
      } finally {
        this.loading = false
      }
    },
    buildQueryParams () {
      const params = {}
      if (this.queryParams.mediaId) params.mediaId = this.queryParams.mediaId
      if (this.queryParams.dspId) params.dspId = this.queryParams.dspId
      if (this.queryParams.dspSlotId) params.dspSlotId = this.queryParams.dspSlotId
      if (this.queryParams.advertiser) params.advertiser = this.queryParams.advertiser
      if (this.queryParams.enabled !== null && this.queryParams.enabled !== '') {
        params.enabled = this.queryParams.enabled
      }
      return params
    },
    handleSearch () {
      this.pagination.pageNum = 1
      this.fetchData()
    },
    handleReset () {
      this.queryParams = {
        mediaId: '',
        dspId: '',
        dspSlotId: '',
        advertiser: '',
        enabled: null
      }
      this.handleSearch()
    },
    handleSizeChange (size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchData()
    },
    handleCurrentChange (page) {
      this.pagination.pageNum = page
      this.fetchData()
    },
    handleSelectionChange (selection) {
      this.selectedIds = selection.map(item => item.id)
    },
    handleAdd () {
      this.$refs.form.show()
    },
    handleEdit (row) {
      this.$refs.form.show(row)
    },
    handleEnabledChange (row) {
      updateCreativeReplaceConfig({
        id: row.id,
        mediaId: row.mediaId,
        dspIds: row.dspIds,
        dspSlotIds: row.dspSlotIds,
        advertiser: row.advertiser,
        creativeSetId: row.creativeSetId,
        enabled: row.enabled,
        replaceStrategy: row.replaceStrategy,
        remark: row.remark
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(row.enabled === 1 ? '已开启' : '已关闭')
        } else {
          row.enabled = row.enabled === 1 ? 0 : 1
        }
      }).catch(() => {
        row.enabled = row.enabled === 1 ? 0 : 1
      })
    },
    handleDelete (row) {
      this.$confirm('确定删除该替换配置吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCreativeReplaceConfig([row.id]).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.fetchData()
          }
        })
      }).catch(() => {})
    },
    handleBatchDelete () {
      this.$confirm(`确定删除选中的 ${this.selectedIds.length} 条配置吗？`, '批量删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCreativeReplaceConfig(this.selectedIds).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.selectedIds = []
            this.fetchData()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: $--common-card-color;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 180px;
  }
}

.table-wrapper {
  padding: 15px;
  background: $--common-card-color;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}
</style>
